import fetch from 'auth/FetchInterceptor'

const AppService = {}

AppService.getJoblist = function (data) {
  var searchParams = new URLSearchParams(data)
  return fetch({
    url: `/candidate/jobrole?${searchParams}`,
    method: 'get',
    headers: {
      'public-request': 'true'
    },
  })
}
AppService.getJoblistByCompany=function({slug, pageNo, itemsPerPage}){
  return fetch({
    url:`/candidate/jobrole/company/${slug}?page=${pageNo}&itemsPerPage=${itemsPerPage}`,
    method:'GET',
    headers: {
      'public-request': 'true'
    },
  })
}
AppService.getJobDetails=function(id){
  return fetch({
    url:`/candidate/jobrole/${id}`,
    method:'get',
    headers: {
      'public-request': 'true'
    },
  })
}
AppService.ApplyForJob=function(data){
  return fetch({
    url:`/candidate/application`,
    method:'post',
    headers: {
      'public-request': 'true'
    },
    data
  })
}

AppService.reapplyForm = data => {
  const searchParams = new URLSearchParams(data)
  return fetch({
    url: `/candidate/application/reapply?${searchParams}`,
    method: 'get',
  })
}

AppService.reApplyForm = (data, id) => {
  return fetch({
    url: `/candidate/application/reapply/${id}`,
    method: 'put',
    data
  })
}

AppService.getAppliedJobs=function(){
  return fetch({
    url:`/candidate/jobrole/applied-jobs`,
    method:'get'
  })
}

AppService.getAppliedJobsById = function(id) {
  return fetch({
    url: `/candidate/jobrole/applied-job/${id}`,
    method: 'get'
  })
}

AppService.checkAlreadyApplied=function(id){
  return fetch({
    url:`/candidate/jobrole/check/${id}`,
    method:'get'
  })
}
AppService.getOtherOpenings=function(id,companyId){
  return fetch({
    url:`/candidate/jobrole/check-for-openings/${id}/${companyId}`,
    method:"GET",
    headers: {
      'public-request': 'true'
    },
  })
}
AppService.getJoblistBycompanyKey=function(key){
  return fetch({
    url:`/candidate/jobrole/list-jobs/${key}`,
    method:'GET',
    headers: {
      'public-request': 'true'
    }

  })
}
AppService.fetchProfile=function(){
  return fetch({
    url:'/candidate/profile',
    method:"GET"
  })
}
AppService.updateProfile=function({data, type}){
  return fetch({
    url:`/candidate/profile/update-profile?type=${type}`,
    method:'PATCH',
    data
  })
}

// Change Password
AppService.changePassword = (data) => {
  return fetch({
    url: `/candidate/profile/change-password`,
    method: 'PUT',
    data
  })
}

//report bug
AppService.reportBug=(data)=>{
  return fetch({
    url:`/candidate/report/add-bug`,
    method:'POST',
    headers: {
			'public-request': 'true'
		},
    data

  })
}

AppService.getCompanyDetails = (slug) => {
  return fetch({
    url: `/candidate/jobrole/company-menu-details/${slug}`,
    method: 'GET',
    headers: {
			'public-request': 'true'
		},
  })
}

// update candidate email
AppService.updateCandidateEmail = ({id, email}) => {
  return fetch({
    url:`/candidate/profile/update-email/${id}`,
    method:'PATCH',
    data: {email}
  })
}

AppService.verifyEmailAddress = (token) => {
  return fetch({
    url:`/candidate/profile/verify-email/${token}`,
    method:'put',
  })
}

export default AppService